import Vue from 'vue'
import Vuex from 'vuex'
import exportModule from './modules/export'

Vue.use(Vuex)

var store = new Vuex.Store({
    modules: {
        export: exportModule
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js